/* vDEV */
(() => {
  
  window.themeObj = {
    
    init: () => {
      const obj = window.themeObj;
      
      obj.templates.init();
      obj.sections.init();
      obj.apps.init();
    },
    
    templates: {
      
      init: () => {
        const obj = window.themeObj.templates;
  
        if (document.body.classList.contains('template-index')) {
          new obj.index();
        
        } else if (document.body.classList.contains('template-page')) {
          new obj.page();
        
        } else if (document.body.classList.contains('template-product')) {
          new obj.product();
        
        } else if (document.body.classList.contains('template-collection')) {
          new obj.collection();
        }
      },
      
      index: class {
  
        constructor() {
          const obj = this;
  
          obj.okendo();   
        }

        okendo() {
          const obj = this;

          obj.okendoEvent();
          
          document.addEventListener('scroll', () => {
            obj.okendoEvent();
          });
        }

        okendoEvent() {
          const obj = this;

          const popup = document.querySelector('.oke-reviewsTab.oke-reviewsTab--small-top-right');
          const bar = document.querySelector('#section-id-announcement-bar');
          const header = document.querySelector('#shopify-section-header');

          if (!popup || !bar || !header) {
            return false;
          }
          
          const scrollThreshold = header.offsetHeight;
        
          if (window.scrollY > bar.offsetHeight + header.offsetHeight) {
            popup.classList.add('is-scrolled');
            
          } else {
            popup.classList.remove('is-scrolled');
          }
        }
      },
      
      collection: class {

        constructor() {
          const obj2 = this;

          obj2.productBlock();
        }

        productBlock() {
          const obj2 = this;

          class ProductBlock extends HTMLElement {

            constructor() {
              super();

              const obj3 = this;
            }

            connectedCallback() {
              const obj3 = this;

              obj3.colors();
            }

            colors() {
              const obj3 = this;

              const colors = obj3.querySelectorAll('.product-block-options__item');

              if (!colors.length) {
                return;
              }

              colors.forEach((color) => {

                color.addEventListener('click', (event) => {
                  event.preventDefault();

                  const activeColor = color.parentNode.querySelector('.product-block-options__item.is-active');

                  if (activeColor) {
                    activeColor.classList.remove('is-active');
                  }

                  color.classList.add('is-active');

                  const formUrl = `${color.getAttribute('href')}?section_id=product-block`;
                  
                  fetch(formUrl)
                    .then((response) => {
                    
                      if (!response.ok) {
                        return false;
                      }
                      
                      return response.text();
                    })
                    .then(response => {
                      return new DOMParser().parseFromString(response, 'text/html');
                    })
                    .then((response) => {
                      const fetchContent = response.querySelector('.block-inner');
                      
                      if (!fetchContent) {
                        return false;
                      }

                      const fetchImage = fetchContent.querySelector('.image-cont__wrapper');
                      const image = obj3.querySelector('.image-cont__wrapper');
                      image.innerHTML = fetchImage.innerHTML;

                      const fetchLabel = fetchContent.querySelector('.product-label-container');
                      const label = obj3.querySelector('.product-label-container');
                      label.innerHTML = fetchLabel.innerHTML;

                      const fetchTitle = fetchContent.querySelector('.innerer h4');
                      const title = obj3.querySelector('.innerer h4');
                      title.innerHTML = fetchTitle.innerHTML;

                      const fetchPrice = fetchContent.querySelector('.product-price');
                      const price = obj3.querySelector('.product-price');
                      price.innerHTML = fetchPrice.innerHTML;

                      theme.loadCarousels(this);
                      theme.ProductBlockManager.loadImages(this);
                    });
                  });
              });
            }
          }

          if (!customElements.get('product-block')) {
            customElements.define('product-block', ProductBlock);
          }
        }
      },

      page: class {
  
        constructor() {
          const obj = this;
  
          obj.wishlist();   
        }
  
        wishlist() {
          const obj = this;
  
          class WishlistLanding extends HTMLElement {
  
            settings = {
              renderInterval: false,
              renderIntervalCount: 0
            }
  
            constructor() {
              super();
              
              const obj2 = this;
              
              obj2.render();
  
              obj2.settings.renderInterval = setInterval(() => {
                obj2.render();
      
                obj2.settings.renderIntervalCount++;
                
                if (obj2.settings.renderIntervalCount > 25) {
                  clearInterval(obj2.settings.renderInterval);
                }
              }, 500);
            }
  
            render() {
              const obj2 = this;
              
              const items = obj2.querySelectorAll('.swym-ui-component .swym-wishlist-grid li');
              
              if (!items.length) {
                return false;
              }
  
              items.forEach((item, itemI) => {
                obj2.renderItem(item);
      
                setTimeout(obj2.renderItem(item), 100 * itemI);
              });
              
              if (obj2.settings.renderInterval) {
                clearInterval(obj2.settings.renderInterval);
              }
            }
      
            renderItem(item) {
              const obj2 = this;
      
              const itemTitle = item.querySelector('.swym-title').innerHTML.trim();
      
              const formUrlQ = `"${itemTitle}"`;
              const formUrl = `/search?type=product&section_id=main-search&q=${encodeURIComponent(formUrlQ)}`;
              
              fetch(formUrl)
                .then((response) => {
                
                  if (!response.ok) {
                    return false;
                  }
                  
                  return response.text();
                })
                .then(response => {
                  return new DOMParser().parseFromString(response, 'text/html');
                })
                .then((response) => {
                  const fetchContent = response.querySelector(`.product-block[data-product-title="${itemTitle}"] .product-label-container`);
                  
                  if (!fetchContent) {
                    return false;
                  }
      
                  const itemImage = item.querySelector('.swym-wishlist-image-wrapper');
                  itemImage.append(fetchContent);
                });
            }
          }
          
          customElements.define('wishlist-landing', WishlistLanding);
        }
      },
      
      product: class {
  
        constructor() {
          const obj = this;

          obj.sizeGuide();
          obj.gallery();
          
          obj.payments();
          obj.form();
          obj.optionSelector();
          obj.stickyBar();
          obj.giftCardModal();
          obj.fbt();
          obj.accordions();
          obj.completeTheLook();
          obj.memberPriceTooltip();
        }

        memberPriceTooltip() {
          const Popper = window.Popper;
          if (!Popper || typeof Popper.createPopper !== 'function') {
            return;
          }

          const bind = (wrap) => {
            if (wrap.dataset.memberPricePopperBound) {
              return;
            }
            wrap.dataset.memberPricePopperBound = '1';

            const trigger = wrap.querySelector('.member-price__tooltip-trigger');
            const bubble = wrap.querySelector('.member-price__tooltip-bubble');
            if (!trigger || !bubble) {
              return;
            }

            const popper = Popper.createPopper(trigger, bubble, {
              placement: 'top',
              strategy: 'fixed',
              modifiers: [
                { name: 'offset', options: { offset: [0, 8] } },
                { name: 'flip', options: { fallbackPlacements: ['bottom', 'left', 'right'] } },
                { name: 'preventOverflow', options: { padding: 8, rootBoundary: 'viewport' } },
              ],
            });

            let hideTimer;

            const show = () => {
              window.clearTimeout(hideTimer);
              bubble.removeAttribute('hidden');
              bubble.classList.add('is-visible');
              trigger.setAttribute('aria-expanded', 'true');
              popper.update();
            };

            const hide = () => {
              bubble.classList.remove('is-visible');
              bubble.setAttribute('hidden', '');
              trigger.setAttribute('aria-expanded', 'false');
            };

            const scheduleHide = () => {
              window.clearTimeout(hideTimer);
              hideTimer = window.setTimeout(hide, 120);
            };

            [trigger, bubble].forEach((el) => {
              el.addEventListener('mouseenter', show);
              el.addEventListener('mouseleave', scheduleHide);
            });

            trigger.addEventListener('click', (e) => {
              if (window.matchMedia('(hover: none)').matches) {
                e.preventDefault();
                bubble.classList.contains('is-visible') ? hide() : show();
              }
            });

            wrap.addEventListener('focusin', (e) => {
              if (typeof e.target.matches === 'function' && e.target.matches(':focus-visible')) {
                show();
              }
            });

            wrap.addEventListener('focusout', () => {
              window.setTimeout(() => {
                if (!wrap.contains(document.activeElement)) {
                  hide();
                }
              }, 0);
            });
          };

          const scan = () => {
            document.querySelectorAll('.member-price__tooltip-wrap').forEach(bind);
          };

          scan();
          document.addEventListener('product:variantChanged', () => {
            window.setTimeout(scan, 0);
          });
        }

        fbt() {
          const widgetWrapper = document.querySelector('product-fbt');
          if (!widgetWrapper) return;
          const section = widgetWrapper.closest('.shopify-section');

          document.addEventListener('rebuy.productsChange', function(event){
            const widget = event.detail.widget;
            const widgetId = parseInt(widget.element.dataset.rebuyId);

            if (widgetId != 121973) {
              return;
            }

            if (widget.data.products && widget.data.products.length > 0) {
              section.classList.remove('hidden');
            }
          });
        }

        sizeGuide() {
          const obj = this;

          class ProductSizeGuide extends HTMLElement {

            constructor() {
              super();

              const obj2 = this;
            }
            
            connectedCallback() {
              const obj2 = this;
  
              const links = obj2.querySelectorAll('.product__size-guide__set-item');
    
              if (!links.length) {
                return false;
              }
              
              links.forEach((link) => {
                link.addEventListener('click', () => {
                  const linkI = link.getAttribute('data-i');
                  
                  const activeLink = link.parentNode.querySelector('.is-active');
                  activeLink.classList.remove('is-active');
                  
                  link.classList.add('is-active');
                  
                  const activeTable = obj2.querySelector('.product__size-guide__table.is-active');
                  activeTable.classList.remove('is-active');
                  
                  const table = obj2.querySelector(`.product__size-guide__table[data-i="${linkI}"]`);
                  table.classList.add('is-active');
                });
              });
            }
          }
          
          if (!customElements.get('product-size-guide')) {
            customElements.define('product-size-guide', ProductSizeGuide);
          }
        }
  
        gallery() {
          const obj = this;

          let hoverTimer = null;
          let isZooming = false;

          const wrapper = document.querySelector('.product-media__zoom');
          const img = document.querySelector('.product-media__zoom img');
          const lens = document.querySelector('.product-media__zoom-lens');
          
          const zoom = 3; // Magnification level
          
          lens.style.backgroundImage = `url(${wrapper.getAttribute('data-zoom-url')})`;
          lens.style.backgroundSize = `${wrapper.offsetWidth * zoom}px ${wrapper.offsetHeight * zoom}px`;

          wrapper.addEventListener('mouseenter', () => {
            
            hoverTimer = setTimeout(() => {
              wrapper.classList.add('is-active');
              
              isZooming = true;
            }, 300);
          });

          lens.addEventListener('mousemove', (event) => {
            
            if (isZooming) {
              moveLens(event);
            }
          });
          
          wrapper.addEventListener('mouseleave', () => {
            wrapper.classList.remove('is-active');
            
            clearTimeout(hoverTimer);
            isZooming = false;
          });
          
          function moveLens(event) {
            const rect = wrapper.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            // Clamp x/y inside the wrapper
            const clampedX = Math.max(0, Math.min(x, wrapper.clientWidth));
            const clampedY = Math.max(0, Math.min(y, wrapper.clientHeight));

            // Get relative position in percentage
            const xPercent = clampedX / wrapper.clientWidth * 100;
            const yPercent = clampedY / wrapper.clientHeight * 100;

            lens.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
          }
        }

        payments() {
          const items = document.querySelectorAll('.product-detail .product-payments__item[data-price-calculation="payments"]');

          if (!items.length) {
            return;
          }

          items.forEach((item) => {
            const itemTitle = item.querySelector('.product-payments__item-title');

            document.addEventListener('product:variantChanged', (event) => {
              const itemVariant = item.querySelector(`script[data-variant-id="${event.detail.variant.id}"]`);
              
              if (!itemVariant) {
                return;
              }

              const temp__itemVariant = document.createElement('div');
              temp__itemVariant.innerHTML = itemVariant.innerHTML.trim();
              itemTitle.textContent = temp__itemVariant.querySelector('.product-payments__item-title').textContent;
            });
          });
        }
  
        form() {
          const options = document.querySelectorAll('.product-form .option-selector');
  
          if (!options.length) {
            return;
          }

          document.addEventListener('product:variantChanged', (event) => {
            const button = document.querySelector('.product-form .quantity-submit-row .quantity-submit-row__submit button[type="submit"]');
            const stickyButton = document.querySelector('.c-sticky-atc__button');

            if (!button || !stickyButton) {
              return;
            }

            const url = `${window.Shopify.routes.root}cart.json`;

            fetch(url)
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then((data) => {
                const item = data.items.find(product => product.id === event.detail.variant.id);

                if (item) {
                  button.innerHTML = button.dataset.addedToCartText;
                  stickyButton.innerHTML = button.dataset.addedToCartText;
                }
              });
          });
  
          for (var i = 0; i < options.length; i++) {
            const option = options[i];
            const optionIndex = option.getAttribute('data-option-index');
            
            const optionItems = option.querySelectorAll('input[type="radio"]');
    
            if (optionItems.length) {
    
              for (var i2 = 0; i2 < optionItems.length; i2++) {
                const optionItem = optionItems[i2];
                
                optionItem.addEventListener('change', () => {
                  const stickyBarWrapper = document.querySelector('.c-sticky-atc');

                  const event = new CustomEvent('product:stickyBar');
                  stickyBarWrapper.dispatchEvent(event);
                });
              }
            }
          }
        }
  
        optionSelector() {
          const obj = this;
          
          obj.optionSelector__event();
          
          document.addEventListener('scroll', () => {
            obj.optionSelector__event();
          });
        }
  
        optionSelector__event() {
          const obj = this;
          
          const optionSelector = document.querySelector('.option-selector-fieldset[data-size-selector] .option-selector__btns');
  
          if (!optionSelector) {
            return false;
          }
  
          const windowWidth = window.innerWidth;
  
          if (optionSelector.classList.contains('is-animating') || optionSelector.classList.contains('is-animated') || windowWidth >= 768 || optionSelector.scrollWidth <= windowWidth) {
            return false;
          }
          
          const scrollTop = document.querySelector('html').scrollTop;
  
          const optionSelector__react = optionSelector.getBoundingClientRect();
  
          if (scrollTop + window.innerHeight / 2 > optionSelector__react.top + optionSelector.offsetHeight) {
  
            setTimeout(() => {
              optionSelector.classList.add('is-animating');
              
              setTimeout(() => {
                optionSelector.classList.add('is-animated');
                optionSelector.classList.remove('is-animating');
              }, 2000);
            }, 1000);
          }
        }
  
        stickyBar() {
          const wrapper = document.querySelector('.c-sticky-atc');
          
          var lastScrollTop = window.pageYOffset;
          
          document.addEventListener('scroll', e => {
  
            if (window.pageYOffset != lastScrollTop) {
              const activeDropdown = wrapper.querySelector('.c-sticky-atc__selector-dropdown.is-active');
  
              if (activeDropdown) {
                activeDropdown.classList.remove('is-active');
              }
            }
          });
  
          const dropdowns = document.querySelectorAll('.c-sticky-atc__selector-dropdown');
    
          if (dropdowns) {
            
            for (var i = 0; i < dropdowns.length; i++) {
              const dropdown = dropdowns[i];
              const dropdownIndex = dropdown.parentNode.getAttribute('data-index');
              
              const dropdownLabel = dropdown.querySelector('.c-sticky-atc__selector-dropdown__label');
  
              dropdownLabel.addEventListener('click', () => {
                const activeDropdown = wrapper.querySelector('.c-sticky-atc__selector-dropdown.is-active');
  
                dropdown.classList.toggle('is-active');
  
                if (activeDropdown) {
                  activeDropdown.classList.remove('is-active');
                }
              });
              
              const dropdownLabelColor = dropdownLabel.querySelector('.c-sticky-atc__selector-dropdown__label-color');
              const dropdownLabelTitle = dropdownLabel.querySelector('.c-sticky-atc__selector-dropdown__label-title');
              
              const dropdownItems = dropdown.querySelectorAll('.c-sticky-atc__selector-dropdown__item');
              
              for (var i2 = 0; i2 < dropdownItems.length; i2++) {
                const dropdownItem = dropdownItems[i2];
    
                dropdownItem.addEventListener('click', () => {
                  dropdown.classList.remove('is-active');
                  const dropdownItemValue = dropdownItem.getAttribute('data-value');
  
                  const dropdownActiveItem = dropdownItem.parentNode.querySelector('.is-active');
                  
                  dropdownItem.classList.add('is-active');
    
                  if (dropdownActiveItem) {
                    dropdownActiveItem.classList.remove('is-active');
                  }
                  
                  const dropdownItemColor = dropdownItem.querySelector('.c-sticky-atc__selector-dropdown__item-color');
  
                  if (dropdownLabelColor && dropdownItemColor) {
                    dropdownLabelColor.setAttribute('data-swatch', dropdownItemColor.getAttribute('data-swatch'));
                  }
                  
                  const dropdownItemTitle = dropdownItem.querySelector('.c-sticky-atc__selector-dropdown__item-title');
                  dropdownLabelTitle.innerHTML = dropdownItemTitle.innerHTML;
  
                  const formField = document.querySelector(`.option-selector[data-option-index="${dropdownIndex}"] input[type="radio"][value="${dropdownItemValue}"]`);
  
                  if (formField && !formField.checked) {
                    formField.click();
                  }
                });
              }
            }
          }
          
          const event = new Event('product:sticky-bar:refresh');
          
          wrapper.addEventListener('product:sticky-bar:refresh', (e) => {
            const form = document.querySelector('.product-form');
            
            const options = form.querySelectorAll('.option-selector');
    
            if (options.length) {
  
              for (var i = 0; i < options.length; i++) {
                const option = options[i];
                const optionIndex = option.getAttribute('data-option-index');
                
                const optionItems = option.querySelectorAll('input[type="radio"]');
  
                if (optionItems.length) {
                  
                  for (var i2 = 0; i2 < optionItems.length; i2++) {
                    const optionItem = optionItems[i2];
                    const optionItemValue = optionItem.value;
        
                    const stickyBarDropdownItem = document.querySelector(`.c-sticky-atc__selector[data-index="${optionIndex}"] .c-sticky-atc__selector-dropdown__item[data-value="${optionItemValue}"]`);
  
                    if (stickyBarDropdownItem) {
      
                      if (optionItem.classList.contains('is-unavailable')) {
                        stickyBarDropdownItem.classList.add('is-disabled');
                      }
                      
                      if (optionItem.checked) {
                        stickyBarDropdownItem.click();
                        stickyBarDropdownItem.classList.add('is-active');
                      }
                    }
                  }
                }
              }
            }
  
            wrapper.classList.remove('is-hidden');
            
          }, false);
          wrapper.dispatchEvent(event);
        }
        
        giftCardModal() {
          const obj = this;
              
          document.addEventListener('theme:modal:opened', (event) => {
            const modal = event.detail.modal;
            const modalGiftCard = modal.querySelector('gift-card-modal');
  
            if (!modalGiftCard) {
              return false;
            }
            
            modalGiftCard.render();
          });
  
          document.addEventListener('theme:modal:closed', (event) => {
            const modal = event.detail.modal;
            const modalGiftCard = modal.querySelector('gift-card-modal');
  
            if (!modalGiftCard) {
              return false;
            }
            
            modalGiftCard.unrender();
          });
  
          class GiftCardModal extends HTMLElement {
  
            settings = {
              datepicker: {
                wrapper: this.querySelector('datepicker-wrapper'),
                modal: this.querySelector('datepicker-modal'),
                button: this.querySelector('datepicker-button'),
                bg: this.querySelector('.datepicker-modal__bg'),
                obj: null
              },
              timepicker: {
                selector: this.querySelector('select#gift-card-popup--timepicker')
              }
            }
  
            constructor() {
              super();
  
              const obj2 = this;
            }
  
            render() {
              const obj2 = this;
  
              const formFields = obj2.querySelectorAll('[data-form]');
    
              if (formFields.length) {
    
                formFields.forEach((formField) => {
                  formField.setAttribute('form', formField.getAttribute('data-form'));
    
                  if (formField.hasAttribute('data-required')) {
                    formField.setAttribute('required', 'required');
                  }
                });
              }
  
              obj2.sendOptions__field();
              obj2.datePicker__field();
              obj2.timezone__field();
              obj2.timePicker__field();
              
              obj2.submitButton();
            }
  
            unrender() {
              const obj2 = this;
  
              const formFields = obj2.querySelectorAll('[data-form][required]');
    
              if (formFields.length) {
    
                formFields.forEach((formField) => {
                  formField.removeAttribute('required');
                });
              }
            }
            
            sendOptions__field() {
              const obj2 = this;
  
              const items = obj2.querySelectorAll('.option-selector__btns label');
    
              items.forEach((item) => {
      
                item.addEventListener('click', () => {
                  const itemInput = item.previousElementSibling;
                  itemInput.click();
    
                  const itemValue = item.getAttribute('data-value');
  
                  /* Fields */
                  const fields = obj2.querySelectorAll(`.column.is-active[data-value]`);
                  
                  fields.forEach((field) => {
                    field.classList.add('hidden');
                    field.classList.remove('is-active');
  
                    const fieldInputs = field.querySelectorAll('*[data-name]');
  
                    if (!fieldInputs.length) {
                      return false;
                    }
  
                    fieldInputs.forEach((fieldInput) => {
                      fieldInput.removeAttribute('name');
                    });
                  });
                  /* /Fields */
    
                  /* /Active fields */
                  const activeFields = obj2.querySelectorAll(`.column[data-value="${itemValue}"]`);
  
                  activeFields.forEach((activeField) => {
                    activeField.classList.remove('hidden');
                    activeField.classList.add('is-active');
  
                    const activeFieldInputs = activeField.querySelectorAll('*[data-name]');
  
                    if (!activeFieldInputs.length) {
                      return false;
                    }
  
                    activeFieldInputs.forEach((activeFieldInput) => {
                      activeFieldInput.setAttribute('name', activeFieldInput.getAttribute('data-name'));
                    });
                  });
                  /* /Active fields */
                });
              });
            }
            
            datePicker__field() {
              const obj2 = this;
  
              const currentDate = new Date();
              const nextMonthDate = new Date(new Date().getTime() + 31 * 24 * 60 * 60 * 1000);
    
              const datepickerButtonInput = obj2.settings.datepicker.button.querySelector('input');
              const datepickerButtonText = obj2.settings.datepicker.button.querySelector('span');
    
              obj2.settings.datepicker.button.addEventListener('click', () => {
                obj2.settings.datepicker.wrapper.classList.toggle('is-active');
              });
              
              obj2.settings.datepicker.obj = new Datepicker(obj2.settings.datepicker.modal, {
                minDate: currentDate.getTime(),
                maxDate: nextMonthDate.getTime()
              });
    
              datepickerButtonInput.value = obj2.settings.datepicker.obj.getFocusedDate('d.m.y');
              datepickerButtonText.innerHTML = datepickerButtonInput.value;
    
              obj2.settings.datepicker.modal.addEventListener('changeDate', () => {
                datepickerButtonInput.value = obj2.settings.datepicker.obj.getFocusedDate('d.m.y');
                datepickerButtonText.innerHTML = datepickerButtonInput.value;
  
                obj2.timePicker__field();
                
                obj2.settings.datepicker.wrapper.classList.remove('is-active');
              });
    
              obj2.settings.datepicker.obj.setDate(currentDate);
              
              obj2.settings.datepicker.bg.addEventListener('click', () => {
                obj2.settings.datepicker.wrapper.classList.remove('is-active');
              });
            }
  
            timePicker__field() {
              const obj2 = this;
              
              const selectorOptions = obj2.settings.timepicker.selector.querySelectorAll('option');
  
              selectorOptions.forEach((selectorOption) => {
                selectorOption.disabled = false;
              });
  
              const nowDate = new Date();
              const nowTime = (60 * 60 * nowDate.getHours()) + (60 * nowDate.getMinutes());
  
              if (nowDate.getTime() >= new Date(obj2.settings.datepicker.obj.getDate())) {
                let selectorOption__found = false;
    
                selectorOptions.forEach((selectorOption, selectorOption__i) => {
                  const selectorOption__time = 60 * 30 * selectorOption__i;
    
                  if (selectorOption__found) {
                    return;
                  }
                  
                  if (selectorOption__time < nowTime) {
                    selectorOption.disabled = true;
    
                  } else {
                    selectorOption.selected = true;
                    selectorOption__found = true;
                  }
                });
              }
            }
  
            timezone__field() {
              const obj2 = this;
  
              const field = obj2.querySelector('input[name="properties[_Timezone]"]');
              field.value = Intl.DateTimeFormat().resolvedOptions().timeZone
            }
  
            submitButton() {
              const obj2 = this;
              
              const modalButton = obj2.querySelector('.button--wide[type="button"]');
              
              const formId = modalButton.getAttribute('data-form');
              const form = document.getElementById(formId);
              const formButton = form.querySelector('.button[type="submit"]');
  
              modalButton.innerText = formButton.innerText;
  
              modalButton.addEventListener('click', () => {
  
                if (form.checkValidity()) {
                  const modal = obj2.closest('.cc-modal-window');
                  
                  const modalClose = modal.querySelector('.cc-modal-window__close');
                  modalClose.click();
    
                  formButton.click();
                  
                } else {
                  form.reportValidity();
                }
              });
            }
          }
  
          customElements.define('gift-card-modal', GiftCardModal);
        }

        accordions() {
          const obj = this;

          const accordions = document.querySelectorAll('.product-detail-accordion .cc-accordion-item__panel');

          if (!accordions.length) {
            return;
          }

          accordions.forEach((accordion) => {
            const accordionButton = accordion.querySelector('.product-detail-accordion__button');

            if (!accordionButton) {
              return;
            }

            const accordionContent = accordion.querySelector('.cc-accordion-item__content');

            if (accordionContent.offsetHeight > 153) {
              accordion.classList.add('is--show-more');
            }
          });
        }

        completeTheLook() {
          const COLOUR_LABEL = 'Colour';
          const WARMTH_LABEL = 'Warmth';
          const SIZE_LABEL = 'Size';
          const CC_SELECT_ICON = '<svg class="cc-select__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';

          const carousels = document.querySelectorAll('.ctl-carousel');
          if (!carousels.length) return;

          function formatMoney(dollarAmount) {
            const n = parseFloat(dollarAmount);
            if (isNaN(n) || n <= 0) return '';
            return '$' + n.toFixed(2).replace(/\.00$/, '');
          }

          function escapeHtml(str) {
            return String(str || '')
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;');
          }

          function swatchKey(value) {
            return String(value || '').replace(/"/g, '').toLowerCase();
          }

          function getVariantOptions(variant, optionCount) {
            if (variant.options && variant.options.length) {
              return variant.options.slice(0, optionCount);
            }
            const opts = [];
            if (variant.option1) opts.push(variant.option1);
            if (variant.option2) opts.push(variant.option2);
            if (variant.option3) opts.push(variant.option3);
            return opts.slice(0, optionCount);
          }

          function normalizeVariants(variants, optionCount) {
            return (variants || []).map(v => ({
              ...v,
              options: getVariantOptions(v, optionCount),
            }));
          }

          function getStitchedOptionValue(product, optionName) {
            const opt = (product.options || []).find(o => o.name === optionName);
            if (opt?.values?.[0]) return opt.values[0];

            const titleParts = (product.title || '').split(' | ');
            if (titleParts[1]) return titleParts[1].trim();

            const firstVariant = product.variants?.[0];
            if (!firstVariant) return '';

            const pos = (product.options || []).findIndex(o => o.name === optionName);
            if (pos === 0) return firstVariant.option1 || '';
            if (pos === 1) return firstVariant.option2 || '';
            if (pos === 2) return firstVariant.option3 || '';
            return '';
          }

          function toStitchedProductEntry(product) {
            const optionCount = (product.options || []).length || 3;
            const variants = normalizeVariants(product.variants, optionCount);
            return {
              id: product.id,
              title: product.title || '',
              handle: product.handle || '',
              url: product.url || (product.handle ? `/products/${product.handle}` : ''),
              variants,
              colour: getStitchedOptionValue(product, COLOUR_LABEL),
              warmth: getStitchedOptionValue(product, WARMTH_LABEL),
              images: product.images,
              featured_image: product.featured_image,
            };
          }

          function getStitchedMetaobjectId(product) {
            const raw = product.metafields?.find(metafield => metafield.namespace === 'custom' && metafield.key === 'stitched_products')?.value;
            if (!raw) return null;
            const entry = Array.isArray(raw) ? raw[0] : raw;
            return typeof entry === 'string' ? entry : null;
          }

          async function enrichStitchedProducts(products, carousel) {
            const storefrontToken = carousel.dataset.storefrontToken;
            const apiKey = carousel.dataset.apiKey;
            if (!storefrontToken) return products;

            const stitchedIds = [];
            products.forEach(product => {
              const id = getStitchedMetaobjectId(product);
              if (id && !stitchedIds.includes(id)) stitchedIds.push(id);
            });

            if (!stitchedIds.length) return products;

            try {
              const response = await fetch('/api/2025-07/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': storefrontToken,
                },
                body: JSON.stringify({
                  query: `
                    query getStitchedProducts($stitchedProductsIds: [ID!]!) {
                      nodes(ids: $stitchedProductsIds) {
                        ... on Metaobject {
                          id
                          products: field(key: "products") {
                            references(first: 100) {
                              nodes {
                                ... on Product {
                                  id
                                  title
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  `,
                  variables: { stitchedProductsIds: stitchedIds },
                }),
              });

              const json = await response.json();
              if (json.errors || !json.data?.nodes) return products;

              const metaobjects = json.data.nodes.filter(Boolean);
              const stitchedProductGids = metaobjects.flatMap(
                node => (node.products?.references?.nodes || []).map(n => n.id)
              );
              const stitchedProductIds = stitchedProductGids.map(
                gid => gid.replace('gid://shopify/Product/', '')
              );

              if (!stitchedProductIds.length) return products;

              const rebuyResponse = await fetch(
                `https://rebuyengine.com/api/v1/products/static?shopify_product_ids=${stitchedProductIds.join(',')}&key=${apiKey}&limit=250&metafields=yes`
              );
              const rebuyJson = await rebuyResponse.json();
              const rebuyProductKey = {};
              (rebuyJson.data || []).forEach(p => {
                rebuyProductKey[p.admin_graphql_api_id] = p;
              });

              return products.map(product => {
                const metaObjectId = getStitchedMetaobjectId(product);
                if (!metaObjectId) return product;

                const metaobject = metaobjects.find(m => m.id === metaObjectId);
                if (!metaobject) return product;

                const stitchedProducts = (metaobject.products?.references?.nodes || [])
                  .map(node => {
                    const rebuyProduct = rebuyProductKey[node.id];
                    return toStitchedProductEntry(rebuyProduct || { id: parseInt(node.id.replace('gid://shopify/Product/', ''), 10), title: node.title, variants: [], options: [] });
                  })
                  .filter(sp => sp.id);

                return { ...product, _stitchedProducts: stitchedProducts };
              });
            } catch (_) {
              return products;
            }
          }

          function findVariant(variants, selectedOptions) {
            return variants.find(v =>
              v.options.every((opt, i) => opt === selectedOptions[i])
            );
          }

          function getOptionValues(product, option, optIdx, stitchedProducts) {
            const isStitchedOption =
              stitchedProducts.length &&
              (option.name === COLOUR_LABEL || option.name === WARMTH_LABEL);

            if (isStitchedOption) {
              const key = option.name === COLOUR_LABEL ? 'colour' : 'warmth';
              const values = [];
              stitchedProducts.forEach(sp => {
                const val = sp[key];
                if (val && !values.includes(val)) values.push(val);
              });
              if (values.length) return values;
            }

            return option.values || [];
          }

          function getVariantImageUrl(variants, optionIndex, optionValue, product) {
            const variant = variants.find(v => v.options[optionIndex] === optionValue);
            if (!variant) return '';

            if (variant.featured_image?.src) return variant.featured_image.src;
            if (variant.image_id && product.images) {
              const img = product.images.find(i => i.id === variant.image_id);
              if (img?.src) return img.src;
            }
            return '';
          }

          function buildSwatchStyles(cardId, product, options, variants, stitchedProducts, swatchOptionNames) {
            if (!swatchOptionNames.length) return '';

            let css = '';
            const productSources = stitchedProducts.length
              ? stitchedProducts
              : [{ variants, images: product.images, featured_image: product.featured_image }];

            options.forEach((option, optIdx) => {
              if (!swatchOptionNames.includes(option.name)) return;

              const values = getOptionValues(product, option, optIdx, stitchedProducts);

              values.forEach(value => {
                let imageUrl = '';
                for (const source of productSources) {
                  imageUrl = getVariantImageUrl(source.variants || [], optIdx, value, source);
                  if (imageUrl) break;
                }
                if (!imageUrl) return;
                css += `[data-ctl-card-id="${cardId}"][data-swatch="${swatchKey(value)}"] { --swatch-background-image: url(${imageUrl}); }`;
              });
            });

            return css ? `<style>${css}</style>` : '';
          }

          function buildCcSelectHtml(id, cardId, optionValues, selectedValue, usesSwatch) {
            const selected = selectedValue || optionValues[0] || '';
            const cardAttr = ` data-ctl-card-id="${cardId}"`;
            const selectedSwatch = usesSwatch && selected ? ` data-swatch="${swatchKey(selected)}"` : '';
            const optionsHtml = optionValues.map((value, i) => {
              const swatchAttr = usesSwatch ? ` data-swatch="${swatchKey(value)}"` : '';
              const selectedAttr = value === selected ? ' aria-selected="true"' : '';
              return `<li class="cc-select__option js-option" id="${id}-opt-${i}" role="option" data-value="${escapeHtml(value)}"${cardAttr}${swatchAttr}${selectedAttr}><span>${escapeHtml(value)}</span></li>`;
            }).join('');

            const selectedId = optionValues.indexOf(selected);
            const activedescendant = selectedId >= 0 ? ` aria-activedescendant="${id}-opt-${selectedId}"` : '';
            const buttonContent = usesSwatch
              ? `<span class="cc-select__label" aria-hidden="true"></span>${CC_SELECT_ICON}`
              : `<span>${escapeHtml(selected)}</span>${CC_SELECT_ICON}`;
            const buttonAriaLabel = usesSwatch && selected ? ` aria-label="${escapeHtml(selected)}"` : '';

            return `
              <div class="cc-select" id="${id}"${cardAttr}>
                <button class="cc-select__btn" type="button" aria-haspopup="listbox"${cardAttr}${selectedSwatch}${buttonAriaLabel}>${buttonContent}</button>
                <ul class="cc-select__listbox" role="listbox" tabindex="-1" aria-hidden="true"${cardAttr}${activedescendant}>
                  ${optionsHtml}
                </ul>
              </div>
            `;
          }

          function resolveVariant(card) {
            const st = card._ctlState;
            if (!st) return;

            const match = findVariant(st.variants, st.selectedOptions);
            st.currentVariantId = match ? match.id : null;

            const saleEl = card.querySelector('.ctl-card__price--sale');
            const compareEl = card.querySelector('.ctl-card__price--compare');
            const addBtn = card.querySelector('.ctl-card__add');

            if (!match) {
              if (saleEl) saleEl.textContent = '—';
              if (compareEl) compareEl.hidden = true;
              if (addBtn) {
                addBtn.dataset.variantId = '';
                addBtn.disabled = true;
              }
              card.dataset.variantId = '';
              return;
            }

            const newSale = parseFloat(match.price) || 0;
            const newCompare = parseFloat(match.compare_at_price) || 0;

            if (saleEl) saleEl.textContent = newSale > 0 ? formatMoney(newSale) : '';
            if (compareEl) {
              compareEl.textContent = newCompare > newSale ? formatMoney(newCompare) : '';
              compareEl.hidden = newCompare <= newSale;
            }
            if (addBtn) {
              addBtn.dataset.variantId = match.id;
              addBtn.disabled = false;
            }
            card.dataset.variantId = match.id;
          }

          function setActiveProduct(card, stitchedProductId, optionValue, optIdx) {
            const st = card._ctlState;
            const stitched = st.stitchedProducts.find(sp => sp.id === stitchedProductId);
            if (!stitched) return;

            const sizeIdx = st.options.findIndex(o => o.name === SIZE_LABEL);
            const preservedSize = sizeIdx >= 0 ? st.selectedOptions[sizeIdx] : null;

            st.activeProductId = stitchedProductId;
            st.variants = stitched.variants || st.variants;
            st.selectedOptions[optIdx] = optionValue;

            if (sizeIdx >= 0 && preservedSize) {
              st.selectedOptions[sizeIdx] = preservedSize;
            }

            const titleEl = card.querySelector('.ctl-card__title');
            if (titleEl && stitched.title) {
              titleEl.textContent = stitched.title;
              titleEl.href = stitched.url || titleEl.href;
            }

            const imageEl = card.querySelector('.ctl-card__image');
            if (imageEl && stitched.images?.length) {
              imageEl.src = stitched.images[0].src + '&width=250';
            }

            resolveVariant(card);
          }

          function portalCtlSelect(ccSelect) {
            const btn = ccSelect.querySelector('.cc-select__btn');
            const listbox = ccSelect.querySelector('.cc-select__listbox');
            if (!btn || !listbox || ccSelect.dataset.ctlPortalInit) return;
            ccSelect.dataset.ctlPortalInit = 'true';

            let placeholder = null;
            let repositionHandler = null;

            const positionListbox = () => {
              const rect = btn.getBoundingClientRect();
              listbox.style.position = 'fixed';
              listbox.style.top = `${rect.bottom + 5}px`;
              listbox.style.left = `${rect.left - 5}px`;
              listbox.style.width = `${rect.width + 10}px`;
              listbox.style.zIndex = '500';
            };

            const restoreListbox = () => {
              if (!placeholder) return;

              placeholder.parentNode.insertBefore(listbox, placeholder);
              placeholder.remove();
              placeholder = null;
              listbox.classList.remove('ctl-card__listbox--portal', 'option-selector--swatch');
              listbox.style.position = '';
              listbox.style.top = '';
              listbox.style.left = '';
              listbox.style.width = '';
              listbox.style.zIndex = '';

              if (repositionHandler) {
                window.removeEventListener('scroll', repositionHandler, true);
                window.removeEventListener('resize', repositionHandler);
                repositionHandler = null;
              }
            };

            const observer = new MutationObserver(() => {
              if (ccSelect.classList.contains('is-open')) {
                if (!placeholder) {
                  placeholder = document.createComment('ctl-listbox-placeholder');
                  listbox.parentNode.insertBefore(placeholder, listbox);
                  document.body.appendChild(listbox);
                  listbox.classList.add('ctl-card__listbox--portal');

                  const optionWrapper = ccSelect.closest('.option-selector');
                  if (optionWrapper?.classList.contains('option-selector--swatch')) {
                    listbox.classList.add('option-selector--swatch');
                  }
                }

                positionListbox();
                repositionHandler = () => {
                  if (ccSelect.classList.contains('is-open')) positionListbox();
                };
                window.addEventListener('scroll', repositionHandler, true);
                window.addEventListener('resize', repositionHandler);
              } else {
                restoreListbox();
              }
            });

            observer.observe(ccSelect, { attributes: true, attributeFilter: ['class'] });
          }

          function initCardSelectors(card) {
            if (typeof jQuery !== 'undefined') {
              jQuery(document).trigger('cc:component:load', ['custom-select', card]);
            }

            card.querySelectorAll('.ctl-card__option .cc-select').forEach(ccSelect => {
              portalCtlSelect(ccSelect);

              ccSelect.addEventListener('change', e => {
                const value = e.detail?.selectedValue;
                if (value === undefined) return;

                const st = card._ctlState;
                const group = ccSelect.closest('.ctl-card__option');
                const optIdx = parseInt(group.dataset.optionIndex, 10);
                const optionName = group.dataset.optionName;

                if (group.classList.contains('option-selector--swatch')) {
                  ccSelect.querySelector('.cc-select__btn')?.setAttribute('aria-label', value);
                }

                if (st.stitchedProducts.length && optionName === COLOUR_LABEL) {
                  const stitched = st.stitchedProducts.find(
                    sp => sp.colour && sp.colour.toLowerCase() === value.toLowerCase()
                  );
                  if (stitched) {
                    setActiveProduct(card, stitched.id, value, optIdx);
                    return;
                  }
                }

                if (st.stitchedProducts.length && optionName === WARMTH_LABEL) {
                  const stitched = st.stitchedProducts.find(
                    sp => sp.warmth && sp.warmth.toLowerCase() === value.toLowerCase()
                  );
                  if (stitched) {
                    setActiveProduct(card, stitched.id, value, optIdx);
                    return;
                  }
                }

                st.selectedOptions[optIdx] = value;
                resolveVariant(card);
              });
            });
          }

          function buildCard(product, config) {
            const card = document.createElement('div');
            const cardId = `ctl-${product.id}`;
            card.className = 'ctl-card';
            card.dataset.cardId = cardId;

            const imageUrl = product.images && product.images.length
              ? product.images[0].src
              : (product.featured_image ? product.featured_image.src : '');

            const callout = product.product_type || '';
            const productUrl = product.url || `/products/${product.handle}`;
            const options = product.options || [];
            const optionCount = options.length || 3;
            const stitchedProducts = product._stitchedProducts || [];
            const variants = normalizeVariants(product.variants, optionCount);
            const swatchOptionNames = config.swatchOptionNames;
            const swatchEnabled = config.swatchEnabled;

            let activeVariants = variants;
            if (stitchedProducts.length) {
              const current = stitchedProducts.find(sp => sp.id === product.id) || stitchedProducts[0];
              if (current?.variants?.length) activeVariants = current.variants;
            }

            const selectedOptions = options.map((opt, idx) => {
              if (stitchedProducts.length && opt.name === COLOUR_LABEL) {
                const current = stitchedProducts.find(sp => sp.id === product.id) || stitchedProducts[0];
                return current?.colour || opt.values?.[0] || '';
              }
              if (stitchedProducts.length && opt.name === WARMTH_LABEL) {
                const current = stitchedProducts.find(sp => sp.id === product.id) || stitchedProducts[0];
                return current?.warmth || opt.values?.[0] || '';
              }
              return opt.values?.[0] || '';
            });

            const firstMatch = findVariant(activeVariants, selectedOptions) || activeVariants[0] || {};
            const allPrices = activeVariants.map(v => parseFloat(v.price) || 0).filter(p => p > 0);
            const allCompare = activeVariants.map(v => parseFloat(v.compare_at_price) || 0).filter(p => p > 0);
            const salePrice = firstMatch.price ? parseFloat(firstMatch.price) : (allPrices.length ? Math.min(...allPrices) : 0);
            const comparePrice = firstMatch.compare_at_price
              ? parseFloat(firstMatch.compare_at_price)
              : (allCompare.length ? Math.max(...allCompare) : 0);

            let optionsHtml = '';
            const hasMultipleVariants = activeVariants.length > 1 || options.some(o => (o.values || []).length > 1);

            if (hasMultipleVariants && options.length) {
              const optionParts = [];
              options.forEach((option, optIdx) => {
                const optionValues = getOptionValues(product, option, optIdx, stitchedProducts);
                if (optionValues.length <= 1) return;

                const usesSwatch = swatchEnabled && swatchOptionNames.includes(option.name);
                const selectId = `${cardId}-opt-${optIdx}`;
                const swatchClass = usesSwatch ? ' option-selector--swatch' : '';

                optionParts.push(`
                  <div class="ctl-card__option option-selector${swatchClass}"
                    data-selector-type="dropdown"
                    data-option-index="${optIdx}"
                    data-option-name="${escapeHtml(option.name)}">
                    ${buildCcSelectHtml(selectId, cardId, optionValues, selectedOptions[optIdx], usesSwatch)}
                  </div>
                `);
              });

              optionsHtml = optionParts.length
                ? `<div class="ctl-card__options">${optionParts.join('')}</div>`
                : '<span class="ctl-card__variant-single"></span>';
            } else {
              optionsHtml = '<span class="ctl-card__variant-single"></span>';
            }

            const swatchStyles = buildSwatchStyles(
              cardId,
              product,
              options,
              activeVariants,
              stitchedProducts,
              swatchOptionNames
            );

            card.innerHTML = `
              ${swatchStyles}
              <div class="ctl-card__main">
                <a href="${productUrl}" class="ctl-card__image-link">
                  <img class="ctl-card__image" src="${imageUrl}" alt="${escapeHtml(product.title)}" loading="lazy" width="111" height="111">
                </a>
                <div class="ctl-card__info">
                  <a href="${productUrl}" class="ctl-card__title">${escapeHtml(product.title)}</a>
                  ${callout ? `<p class="ctl-card__callout">${escapeHtml(callout)}</p>` : ''}
                  <div class="ctl-card__price">
                    <span class="ctl-card__price--sale">${salePrice > 0 ? formatMoney(salePrice) : ''}</span>
                    <span class="ctl-card__price--compare" ${comparePrice > salePrice ? '' : 'hidden'}>${comparePrice > salePrice ? formatMoney(comparePrice) : ''}</span>
                  </div>
                </div>
              </div>
              <div class="ctl-card__footer">
                ${optionsHtml}
                <button class="ctl-card__add button button--secondary" type="button" data-variant-id="${firstMatch.id || ''}"${!firstMatch.id ? ' disabled' : ''}>Add</button>
              </div>
            `;

            card._ctlState = {
              variants: activeVariants,
              options,
              stitchedProducts,
              activeProductId: product.id,
              selectedOptions,
              currentVariantId: firstMatch.id || null,
            };

            card.dataset.variantId = firstMatch.id || '';

            if (hasMultipleVariants && options.length && card.querySelector('.ctl-card__options')) {
              initCardSelectors(card);
              resolveVariant(card);
            }

            return card;
          }

          carousels.forEach((carousel) => {
            const productId = carousel.dataset.productId;
            const apiKey = carousel.dataset.apiKey;
            const limit = carousel.dataset.limit || 8;
            const track = carousel.querySelector('.ctl-track');
            const dotsContainer = carousel.querySelector('.ctl-dots');
            const loading = carousel.querySelector('.ctl-loading');
            const empty = carousel.querySelector('.ctl-empty');
            const ctlSection = carousel.closest('.ctl-section');
            const navPrev = ctlSection ? ctlSection.querySelector('.ctl-nav__btn--prev') : null;
            const navNext = ctlSection ? ctlSection.querySelector('.ctl-nav__btn--next') : null;

            const config = {
              swatchEnabled: carousel.dataset.swatchEnabled === 'true',
              swatchOptionNames: (carousel.dataset.swatchOptionNames || '')
                .split(',')
                .map(s => s.trim())
                .filter(Boolean),
            };

            function getActiveIndex() {
              const cards = track.querySelectorAll('.ctl-card');
              if (!cards.length) return 0;
              let closest = 0;
              let minDist = Infinity;
              cards.forEach((card, i) => {
                const dist = Math.abs(card.offsetLeft - track.scrollLeft);
                if (dist < minDist) { minDist = dist; closest = i; }
              });
              return closest;
            }

            function scrollToSlide(index) {
              const cards = track.querySelectorAll('.ctl-card');
              if (!cards[index]) return;
              track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
            }

            function updateDots() {
              const activeIndex = getActiveIndex();
              const cards = track.querySelectorAll('.ctl-card');
              dotsContainer.querySelectorAll('.ctl-dots__dot').forEach((dot, i) => {
                dot.classList.toggle('is-active', i === activeIndex);
              });
              if (navPrev) navPrev.disabled = activeIndex === 0;
              if (navNext) navNext.disabled = activeIndex >= cards.length - 1;
            }

            fetch(`https://rebuyengine.com/api/v1/custom/id/132139?key=${apiKey}&shopify_product_ids=${productId}&limit=${limit}&metafields=yes`)
              .then(r => r.json())
              .then(data => enrichStitchedProducts(data.data || [], carousel))
              .then(products => {
                loading.hidden = true;

                if (!products.length) {
                  empty.hidden = false;
                  if (ctlSection) ctlSection.hidden = true;
                  return;
                }

                products.forEach(product => {
                  track.appendChild(buildCard(product, config));
                });

                products.forEach((_, i) => {
                  const dot = document.createElement('button');
                  dot.type = 'button';
                  dot.className = 'ctl-dots__dot' + (i === 0 ? ' is-active' : '');
                  dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
                  dot.addEventListener('click', () => scrollToSlide(i));
                  dotsContainer.appendChild(dot);
                });

                track.querySelectorAll('.ctl-card__add').forEach(btn => {
                  btn.addEventListener('click', () => {
                    const card = btn.closest('.ctl-card');
                    const variantId = parseInt(card.dataset.variantId || btn.dataset.variantId);
                    if (!variantId) return;

                    btn.textContent = 'Adding\u2026';
                    btn.disabled = true;

                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: variantId, quantity: 1 })
                    })
                    .then(r => r.json())
                    .then(() => {
                      btn.textContent = 'Added!';
                      document.dispatchEvent(new CustomEvent('theme:cartchanged', {
                        bubbles: true,
                        detail: { openDrawer: true }
                      }));
                      setTimeout(() => {
                        btn.textContent = 'Add';
                        btn.disabled = false;
                      }, 2000);
                    })
                    .catch(() => {
                      btn.textContent = 'Error';
                      btn.disabled = false;
                    });
                  });
                });

                track.addEventListener('scroll', updateDots, { passive: true });

                if (navPrev) navPrev.addEventListener('click', () => scrollToSlide(Math.max(0, getActiveIndex() - 1)));
                if (navNext) navNext.addEventListener('click', () => scrollToSlide(Math.min(track.querySelectorAll('.ctl-card').length - 1, getActiveIndex() + 1)));

                updateDots();
              })
              .catch(() => {
                loading.hidden = true;
                empty.hidden = false;
              });
          });
        }
      }
    },
    
    sections: {
      
      init: () => {
        const obj = window.themeObj.sections;
      
        new obj.announcementBar();
        new obj.slideshow();
        
        obj.accordions();
        obj.multiColumnReadMore();
      },

      accordions: () => {
        const accordions = document.querySelectorAll('.collapsible-tabs__block .cc-accordion-item');

        if (!accordions.length) {
          return;
        }

        accordions.forEach((accordion) => {
          const accordionTitle = accordion.querySelector('.cc-accordion-item__title');

          if (!accordionTitle) {
            return;
          }

          accordionTitle.addEventListener('click', () => {
            const accordion = accordionTitle.closest('.cc-accordion-item');
            const scrollYBefore = window.scrollY;

            const activeAccordion = accordion.closest('.cc-accordion').querySelector('.cc-accordion-item.is-open');

            if (activeAccordion && activeAccordion != accordion) {
              activeAccordion.classList.remove('is-open');
              activeAccordion.removeAttribute('open');
            }

            setTimeout(() => {
              window.scrollTo({
                top: scrollYBefore,
                behavior: 'smooth'
              });
            }, 500);
          });
        });
      },

      multiColumnReadMore: () => {
        const readMoreButtons = document.querySelectorAll('.text-column__read-more-btn');

        if (!readMoreButtons.length) {
          return;
        }

        readMoreButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const textId = button.getAttribute('data-text-id');
            const fullTextId = button.getAttribute('data-full-text-id');
            const textElement = document.getElementById(textId);
            const fullTextScript = document.getElementById(fullTextId);
            const truncateLength = button.getAttribute('data-truncate-length');

            if (!textElement) {
              return;
            }

            const isExpanded = button.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
              // Collapse
              const fullText = fullTextScript ? JSON.parse(fullTextScript.textContent) : '';
              const plainText = fullText.replace(/<[^>]*>/g, '');
              textElement.innerHTML = plainText.substring(0, (truncateLength - 3)) + '...';
              textElement.classList.add('text-column__text--truncated');
              button.textContent = 'Read more';
              button.setAttribute('aria-expanded', 'false');
            } else {
              // Expand
              if (fullTextScript) {
                const fullText = JSON.parse(fullTextScript.textContent);
                console.log(fullText);
                textElement.innerHTML = fullText;
              }
              textElement.classList.remove('text-column__text--truncated');
              button.textContent = 'Read less';
              button.setAttribute('aria-expanded', 'true');
            }
          });
        });
      },
    
      announcementBar: class {
  
        data = {}
        
        constructor() {
          const obj = this;
          
          obj.timer();
        }
  
        timer() {
          const obj = this;
  
          class AnnouncementTimer extends HTMLElement {
  
            settings = {
              date: this.getAttribute('data-date')
            }
  
            constructor() {
              super();
              
              const obj2 = this;
              
              obj2.render();
            }
  
            render() {
              const obj2 = this;
              
              obj2.classList.add('is-rendered');
              
              obj2.settings.interval = setInterval(() => {
                obj2.refresh();
              }, 1000);
            }
  
            refresh() {
              const obj2 = this;
  
              const itemTime = new Date(obj2.settings.date).getTime();
            
              const nowTime = new Date().getTime();
              const distanceTime = itemTime - nowTime;
            
              const itemTimeDays = Math.floor(distanceTime / (1000 * 60 * 60 * 24));
              const itemTimeHours = Math.floor((distanceTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const itemTimeMinutes = Math.floor((distanceTime % (1000 * 60 * 60)) / (1000 * 60));
              const itemTimeSeconds = Math.floor((distanceTime % (1000 * 60)) / 1000);
            
              if (distanceTime < 0) {
                obj2.remove();
                clearInterval(obj2.settings.interval);
                
              } else {
                obj2.innerHTML = `${itemTimeDays}d <span>${itemTimeHours < 10 ? 0 : ''}${itemTimeHours}h</span> <span>${itemTimeMinutes < 10 ? 0 : ''}${itemTimeMinutes}m</span> <span>${itemTimeSeconds < 10 ? 0 : ''}${itemTimeSeconds}s</span>`;
              }
            }
          }
          
          customElements.define('announcement-timer', AnnouncementTimer);
        }
      },
      
      slideshow: class {
  
        data = {}
        
        constructor() {
          const obj = this;
          
          obj.timer();
        }
  
        timer() {
          const obj = this;
  
          class SlideshowTimer extends HTMLElement {
  
            settings = {
              date: this.getAttribute('data-date')
            }
  
            constructor() {
              super();
              
              const obj2 = this;
              
              obj2.render();
            }
  
            render() {
              const obj2 = this;
              
              obj2.classList.add('is-rendered');
              
              obj2.settings.interval = setInterval(() => {
                obj2.refresh();
              }, 1000);
            }
  
            refresh() {
              const obj2 = this;
  
              const itemTime = new Date(obj2.settings.date).getTime();
            
              const nowTime = new Date().getTime();
              const distanceTime = itemTime - nowTime;
            
              const itemTimeDays = Math.floor(distanceTime / (1000 * 60 * 60 * 24));
              const itemTimeHours = Math.floor((distanceTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const itemTimeMinutes = Math.floor((distanceTime % (1000 * 60 * 60)) / (1000 * 60));
              const itemTimeSeconds = Math.floor((distanceTime % (1000 * 60)) / 1000);
            
              if (distanceTime < 0) {
                obj2.remove();
                clearInterval(obj2.settings.interval);
                
              } else {
                obj2.innerHTML = `${itemTimeDays}d <span>${itemTimeHours < 10 ? 0 : ''}${itemTimeHours}h</span> <span>${itemTimeMinutes < 10 ? 0 : ''}${itemTimeMinutes}m</span> <span>${itemTimeSeconds < 10 ? 0 : ''}${itemTimeSeconds}s</span>`;
              }
            }
          }
          
          customElements.define('slideshow-timer', SlideshowTimer);
        }
      }
    },

    apps: {

      init: () => {
        const obj = window.themeObj.apps;
        
        obj.rebuy();
        obj.okendo();
        obj.stampedLoyalty();
      },
    
      rebuy: () => {
        const obj = window.themeObj.apps;
        
        class rebuyProductBlock extends HTMLElement {

          constructor() {
            super();
          }

          connectedCallback() {
            const obj2 = this;

            obj2.swatches();
          }

          wishlist() {
            const obj2 = this;
            
            const button = obj2.querySelector('.swym-button');
                  
            const event = new CustomEvent('swym:button:render', {
              detail: {
                button: button
              }
            });
            document.dispatchEvent(event);
          }

          swatches() {
            const obj2 = this;
            
            if (!obj2.hasAttribute('data-product-handle')) {
              return false;
            }

            const url = `${window.Shopify.routes.root}products/${obj2.getAttribute('data-product-handle')}?section_id=rebuy-product-block`;

            fetch(url)
              .then((response) => {
              
                if (!response.ok) {
                  return false;
                }
                
                return response.text();
              })
              .then(response => {
                return new DOMParser().parseFromString(response, 'text/html');
              })
              .then(response => {
                obj2.classList.add('is-rendered');
                
                const fetchedLabels = response.querySelector('.product-label-container');
                const labels = obj2.querySelector('.product-label-container');

                if (fetchedLabels && labels) {
                  labels.innerHTML = fetchedLabels.innerHTML;
                }
                
                const fetchedWishlist = response.querySelector('.product-block-wishlist');
                const wishlist = obj2.querySelector('.product-block-wishlist');

                if (fetchedWishlist && wishlist) {
                  wishlist.innerHTML = fetchedWishlist.innerHTML;
                }
                
                obj2.wishlist();
                
                const fetched__productBlockBase = response.querySelector('.product-block__base');
                const productBlockBase = obj2.querySelector('.product-block__base');

                if (fetched__productBlockBase && productBlockBase) {
                  productBlockBase.innerHTML = fetched__productBlockBase.innerHTML;
                  
                  const event = new CustomEvent('theme:productBlockBase:init', {
                    detail: {
                      productBlockBase: productBlockBase
                    }
                  });
                  document.dispatchEvent(event);
                }
              });
          }
        }
        
        if (!customElements.get('rebuy-product-block')) {
            customElements.define('rebuy-product-block', rebuyProductBlock);
        }

        const bg = document.querySelector('.show-search-form__bg');

        if (bg) {

          bg.addEventListener('click', () => {
            document.body.classList.remove('rebuy__search-popup--opened');
          });
        }
        
        document.addEventListener('rebuy:smartsearch.quickview.ready', (event) => {
          const input = document.getElementById('searchInput');
          
          if (!input) {
            return false;
          }
          
          input.addEventListener('focus', () => {
            document.body.classList.add('rebuy__search-popup--opened');
          });
          
          const close = document.querySelector('.rebuy-quick-view-dropdown__close');
  
          close.addEventListener('click', () => {
            document.body.classList.remove('rebuy__search-popup--opened');
          });

          const search = document.getElementById('rebuy-quick-view-dropdown-search');
          search.style.setProperty('--header-height', `${search.getBoundingClientRect().top}px`);
        });
        
        document.addEventListener('rebuy:smartsearch.quickview.open', (event) => {
          document.body.classList.add('rebuy__search-popup--opened');
        });
      },

      stampedLoyalty: () => {
        const obj = window.themeObj.sections;

        function addEventListenerStamped(el, eventName, handler) {
          if (el.addEventListener) { el.addEventListener(eventName, handler); }
          else { el.attachEvent('on' + eventName, function () { handler.call(el); }); }
        }

        addEventListenerStamped(document, 'stamped:launcher:opened', () => {
          document.body.classList.add('stamped-rewards__popup--opened');
        });
        
        addEventListenerStamped(document, 'stamped:launcher:closed', () => {
          document.body.classList.remove('stamped-rewards__popup--opened');
        });
      },
    
      okendo: () => {
        const obj = window.themeObj.sections;
  
        let interval;
        
        const item = document.querySelector('.announcement-bar [data-oke-all-reviews]');
  
        if (!item) {
          return false;
        }
        
        interval = setInterval(() => {
          const itemOkendoJson = item.querySelector('script[data-oke-metafield-data]');
  
          if (!itemOkendoJson) {
            return false;
          }
  
          const itemOkendo = JSON.parse(itemOkendoJson.innerText);
  
          if (itemOkendo.averageRating > 0) {
            document.body.style.setProperty('--okendo-avarage-rating', `'${itemOkendo.averageRating}'`);
            clearInterval(interval);
          }
          
        }, 500);
      }
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    window.themeObj.init();
  });
  
})();
/* /vDEV */